import 'magnific-popup';

export default () => {
  $( '.js-popup-modal' ).magnificPopup( {
    type: 'inline',
    preloader: false,
    mainClass: 'mfp-popup',
    closeOnBgClick: false,
    callbacks: {
      open: function() {
          // Bind mousedown event to document to detect mousedown events
          $(document).on('mousedown', function(event) {
              // Check if the clicked element is outside the popup
              if (!$(event.target).closest('.popup-bg').length) {
                  // Close the popup
                  $.magnificPopup.close();
              }
          });
      },
      close: function() {
          // Unbind mousedown event when the popup is closed
          $(document).off('mousedown');
      }
    }
  });
};
